import React, { useState } from "react";
import PropTypes from "prop-types";
import { RadioGroup } from "components/common/FormControls";
import { Button } from "@material-ui/core";

const FormStep3 = ({ styles, handleFormChange, data, setStepNo, formData }) => {
    const [petData, setPetData] = useState(data);

    const handleOnChange = (e, value) => {
        setPetData({
            ...petData,
            [value.name]: value.value,
        });
    };

    const handleSubmit = () => {
        handleFormChange(petData);
        setStepNo(4);
    };

    const heading1 = `${formData?.petName?.trim()}, cute name!`;
    const heading2 = `Is ${formData?.petName?.trim()} a <b>cat or a dog</b>?`;

    return (
        <>
            <div className="conversationalForm__container__formContainer__petData">
                <div className="conversationalForm__container__formContainer__petData__heading">
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__desktop"
                        dangerouslySetInnerHTML={{
                            __html: heading1,
                        }}
                    />
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__desktop"
                        dangerouslySetInnerHTML={{
                            __html: heading2,
                        }}
                    />
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__mobile"
                        dangerouslySetInnerHTML={{
                            __html: `${heading1} ${heading2}`,
                        }}
                    />
                </div>
                <div className="conversationalForm__container__formContainer__petData__inputDiv">
                    <div className="conversationalForm__container__formContainer__petData__inputDiv__fieldGroup">
                        <RadioGroup
                            options={[
                                {
                                    id: "dog",
                                    value: "DOG",
                                    label: "Dog",
                                    active_url:
                                        "https://fetch-sales-funnel.cdn.prismic.io/fetch-sales-funnel/06562be2-90dc-4dbd-b005-a6abd86325a5_dog-active-dodo.svg",
                                    url: "https://fetch-sales-funnel.cdn.prismic.io/fetch-sales-funnel/632ba2e5-4e21-4875-b85f-c187672799d5_dog-inactive-dodo.svg",
                                },
                                {
                                    id: "cat",
                                    value: "CAT",
                                    label: "Cat",
                                    active_url:
                                        "https://fetch-sales-funnel.cdn.prismic.io/fetch-sales-funnel/55640849-84c0-4baf-a0af-15612584b779_cat-active-dodo.svg",
                                    url: "https://fetch-sales-funnel.cdn.prismic.io/fetch-sales-funnel/e2535c91-9c3a-47c7-b015-f960b45e26db_cat-inactive-dodo.svg",
                                },
                            ]}
                            defaultValue={petData.petType}
                            onChange={handleOnChange}
                            name="petType"
                        />
                    </div>
                </div>
                <div className="conversationalForm__container__formContainer__petData__button">
                    <Button
                        type="button"
                        size="large"
                        onClick={handleSubmit}
                        fullWidth
                        variant="contained"
                        id="submit"
                        className={"submit-button"}
                        style={{ ...styles?.button?.active }}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </>
    );
};

FormStep3.propTypes = {
    styles: PropTypes.object,
    handleFormChange: PropTypes.func,
    data: PropTypes.object,
    setStepNo: PropTypes.func,
    formData: PropTypes.object,
};

export default FormStep3;
